import RoomJungleEdit from './RoomJungleEdit.vue';
import RoomJungle from './RoomJungle.vue';
export { RoomJungleEdit };
export default RoomJungle;
